import { post } from '../axios'

export const sync = (params) => post('/intl/openapi/score/v1/cardholder-transaction-score-web/sync', params)
